"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RadioGroup = exports.Radio = void 0;
exports.useHandleRadioSelect = useHandleRadioSelect;
var _react = _interopRequireWildcard(require("react"));
var _framerMotion = require("framer-motion");
require("./RadioGroup.css");
var _tokens = require("@cbhq/cds-common/motion/tokens");
var _Icon = require("../icons/Icon");
var _layout = require("../layout");
var _tokens2 = require("../tokens");
var _linaria = require("../utils/linaria");
var _Control = require("./Control");
var _useControlMotionProps = require("./useControlMotionProps");
const _excluded = ["children"],
  _excluded2 = ["label", "value", "onChange", "options", "name", "testID"];
/* eslint-disable @typescript-eslint/no-use-before-define */
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
const RadioWithRef = /*#__PURE__*/(0, _react.forwardRef)(function RadioWithRef(_ref, ref) {
  let children = _ref.children,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const _props$checked = props.checked,
    checked = _props$checked === void 0 ? false : _props$checked;
  const _useControlMotionProp = (0, _useControlMotionProps.useControlMotionProps)({
      checked,
      shouldAnimateBackground: false
    }),
    outerContainerMotionProps = _useControlMotionProp.outerContainerMotionProps,
    innerContainerMotionProps = _useControlMotionProp.innerContainerMotionProps;
  return /*#__PURE__*/_react.default.createElement(_Control.Control, _extends({
    ref: ref,
    background: "background",
    borderRadius: "roundedFull",
    label: children,
    type: "radio"
  }, props), /*#__PURE__*/_react.default.createElement(_framerMotion.m.div, _extends({
    className: (0, _linaria.cx)(radio, focusRing),
    "data-filled": checked,
    role: "presentation"
  }, outerContainerMotionProps), /*#__PURE__*/_react.default.createElement(_framerMotion.m.div, innerContainerMotionProps, checked && /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    color: "primary",
    name: "dot",
    size: "s"
  }))));
});
const Radio = /*#__PURE__*/(0, _react.memo)(RadioWithRef);
exports.Radio = Radio;
function useHandleRadioSelect(onChange) {
  return (0, _react.useCallback)(event => {
    onChange === null || onChange === void 0 ? void 0 : onChange(event.target.value);
  }, [onChange]);
}
const RadioGroupWithRef = /*#__PURE__*/(0, _react.forwardRef)(function RadioGroup(_ref2, ref) {
  let label = _ref2.label,
    value = _ref2.value,
    onChange = _ref2.onChange,
    options = _ref2.options,
    name = _ref2.name,
    testID = _ref2.testID,
    restProps = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  const handleSelect = useHandleRadioSelect(onChange);
  return /*#__PURE__*/_react.default.createElement(_layout.Group, _extends({
    ref: ref,
    role: "radiogroup",
    testID: testID
  }, restProps), label, Object.entries(options).map(([optionValue, option]) => /*#__PURE__*/_react.default.createElement(Radio, {
    key: optionValue,
    checked: value === optionValue,
    id: `${name}-${optionValue}`,
    name: name,
    onChange: handleSelect,
    testID: testID ? `${testID}-${optionValue}` : undefined,
    value: optionValue
  }, option)));
});
const RadioGroup = /*#__PURE__*/(0, _react.memo)(RadioGroupWithRef);
exports.RadioGroup = RadioGroup;
const FOCUS_PADDING = `calc(-1 * (4px + ${_tokens2.borderWidth.checkbox}))`;
const radio = "cds-radio-r192nysd";
const focusRing = "cds-focusRing-fgra0oq";